import { validateAndTrackEntryPagesEvent } from '@vp/entry-pages-tracking-helpers'
import type { Logger } from '@vp/ubik-logging'

export const trackMapEvent = (
  pageZone: string,
  placementVariantId: string,
  placementDefinitionId: string,
  action: 'click' | 'view',
  logger: Logger,
  schema: object,
) => {
  const eventData = {
    label: `MAP tracking homepage ${pageZone} ${action}`,
    experimentName: `MAP_tracking_${pageZone}`,
    variationName: placementVariantId,
    experimentDetail: placementDefinitionId,
    impressionEventVersion: 3,
  }

  validateAndTrackEntryPagesEvent('Experiment Clicked', eventData, schema, logger)
}
